import classNames from "classnames"

import Link from "@components/elements/Link"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import {
  getAccentColor,
  getBackgroundColorClass,
  getBorderColorClass,
  getTransparentBorderColorClass,
} from "@utils/V2/color"
import React from "react"

type CategoryTabProps = {
  label: string
  count: number
  linkPath?: string
  isActive: boolean
  textColor: Color
}

const CategoryTab = ({
  label,
  count,
  linkPath,
  isActive,
  textColor,
}: CategoryTabProps) => {
  const activeTextColor = getAccentColor(textColor)
  const tabTextColor = isActive ? activeTextColor : textColor

  const tabClassName = classNames(
    "flex min-w-[65px] shrink-0 items-center justify-center whitespace-nowrap rounded-32 border py-8 pl-[18px] pr-12 transition-colors duration-300 md:min-w-[75px] md:py-10 md:pl-[26px]",
    isActive ? "h-40 md:h-[46px]" : "h-[42px] md:h-[46px]",
    isActive
      ? [getBorderColorClass(textColor), getBackgroundColorClass(textColor)]
      : getTransparentBorderColorClass(textColor),
    linkPath && "cursor-pointer",
    linkPath && !isActive && "hover:bg-gray"
  )

  const tabContent = (
    <span className="flex items-start gap-4">
      <Typography
        element="span"
        size="body-md-dual"
        font="grotesk"
        weight="medium"
        color={tabTextColor}
        text={label}
        leadingNone
      />
      <Typography
        element="span"
        size="subscript-sm"
        font="grotesk"
        weight="book"
        color={tabTextColor}
        text={`${count}`}
        className="min-w-[14px] opacity-50"
        leadingNone
      />
    </span>
  )

  if (!linkPath) {
    return <div className={tabClassName}>{tabContent}</div>
  }

  return (
    <Link link={linkPath} className={tabClassName}>
      {tabContent}
    </Link>
  )
}

export default CategoryTab
